"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StorySeo = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const theme_kit_core_1 = require("@prezly/theme-kit-core");
const next_seo_1 = require("next-seo");
/**
 * This components provides additional page attributes for the Story page.
 * It works in conjunction with `PageSeo` component, overidding some of its attributes.
 */
function StorySeo({ story, noindex }) {
    const { title, subtitle, published_at, updated_at, author, oembed, newsroom, summary } = story;
    const authorName = author?.display_name || author?.email || 'Unknown';
    const seoTitle = story.seo_settings.meta_title || story.seo_settings.default_meta_title || title;
    const seoDescription = story.seo_settings.meta_description ||
        story.seo_settings.default_meta_description ||
        subtitle ||
        summary;
    const canonical = story.seo_settings.canonical_url || oembed.url;
    const indexable = newsroom.is_indexable && story.visibility === theme_kit_core_1.Visibility.PUBLIC;
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(next_seo_1.NextSeo, { title: seoTitle, description: seoDescription, canonical: canonical, noindex: noindex || !indexable, nofollow: noindex || !indexable, openGraph: {
                    title,
                    description: seoDescription,
                    url: oembed.url,
                    site_name: newsroom.display_name,
                    type: 'article',
                    article: {
                        publishedTime: published_at || undefined,
                        modifiedTime: updated_at,
                        authors: [authorName],
                    },
                    ...(oembed.thumbnail_url && {
                        images: [
                            {
                                url: oembed.thumbnail_url,
                                alt: oembed.title,
                                width: oembed.thumbnail_width,
                                height: oembed.thumbnail_height,
                            },
                        ],
                    }),
                }, additionalMetaTags: oembed.thumbnail_url
                    ? [
                        { name: 'twitter:card', content: 'summary_large_image' },
                        { name: 'twitter:image', content: oembed.thumbnail_url },
                    ]
                    : undefined, additionalLinkTags: [
                    {
                        rel: 'alternate',
                        type: 'application/json',
                        href: `${oembed.url}.json`,
                    },
                ] }), (0, jsx_runtime_1.jsx)(next_seo_1.ArticleJsonLd, { url: oembed.url, title: title, images: oembed.thumbnail_url ? [oembed.thumbnail_url] : [], datePublished: published_at || '', dateModified: updated_at, authorName: [authorName], publisherName: newsroom.display_name, publisherLogo: newsroom.thumbnail_url, description: seoDescription })] }));
}
exports.StorySeo = StorySeo;
//# sourceMappingURL=StorySeo.js.map